/* !
 * news.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const pathDirList = (FUNCTIONS.va.region === '/') ? location.pathname.slice(1).split('/') :
		location.pathname.replace(new RegExp(FUNCTIONS.va.region, 'g'), '').split('/');

	const infoYearGenerator = () => {
		const $latestY = document.querySelector('.rt_latest_year');
		let $head = document.querySelector('.mod-yearSelect-head');

		if ($head && $latestY) {
			const latestY = Number($latestY.textContent);
			const startY = latestY - 6;

			if (pathDirList[0] === 'news') {
				// 企業配下
				for (let i = latestY; i >= startY; i--) {
					let $this = $head.nextElementSibling.appendChild(document.createElement('li')).appendChild(document.createElement('a'));
					$this.setAttribute('href', `${FUNCTIONS.va.region}news/news-release/${i}/`);
					$this.textContent = i;
				}
			} else {
				// 各事業配下
				const thisCat = pathDirList[0];
				for (let i = latestY; i >= startY; i--) {
					let $this = $head.nextElementSibling.appendChild(document.createElement('li')).appendChild(document.createElement('a'));
					$this.setAttribute('href', `${FUNCTIONS.va.region}${thisCat}/news/news-release/${i}/`);
					$this.textContent = i;
				}
			}
			// 現在年を選択状態にする
			if (location.pathname.indexOf('news-release') !== -1) {
				$head.getElementsByTagName('span')[0].textContent = location.pathname.slice(-5, -1);
			}
		}

		$head.addEventListener('click', (e) => {
			e.currentTarget.classList.toggle(a);
			e.currentTarget.nextElementSibling.classList.toggle(a);
		});
	};





	infoYearGenerator();

})(window.FUNCTIONS);
